<template>
	<div
	 class="basic-info-finish-box"
	 @click="backBasic"
	>
		<div class="basic-user-info-finish-tit">
			<span>个人资料</span>
			<div class="modify">
				<span>修改</span>
				<i class="icon-modify"></i>
			</div>
		</div>
		<div class="basic-info-finish">
			<img
			 :src="photoUrl"
			 class="basic-info-finish-pic"
			>
			<div class="basic-info-finish-detail">
				<div class="basic-info-finish-name">
					<div class="name">{{truename}}</div>
					<div
					 class="personal-info"
					 :class="sexBoxClass"
					>
						<i
						 class="sex"
						 :class="sexClass"
						></i>
						<span class="age">{{age}}</span>
					</div>
				</div>
				<div class="basic-info-finish-other">
					<span class="save-edu">{{educationText}}</span>
					<span class="save-job">{{workExperience}}</span>
					<span class="save-phone">{{mobile}}</span>
				</div>
				<!-- 最高学历信息 -->
				<div
				 class="basic-info-finish-edu"
				 v-if="needEducation"
				>
					<span class="edu-item">{{getHighEdu.school}}</span>
					<span class="edu-item">{{getHighEdu.professional}}专业</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import config from "../../../util/config";
import { mapGetters } from "vuex";
export default {
	data() {
		return {
			photoUrl:
				"//img.58cdn.com.cn/m58/app58/m_static/img/job/resume/newReleaseImg/user_default@2x.png", // 默认头像
			sexClass: "sex-male",
			age: "",
			educationText: "",
			workExperience: ""
		};
	},
	computed: {
		...mapGetters([
			"pic",
			"truename",
			"gender",
			"mobile",
			"birthday",
			"education",
			"workyears",
			"educations",
			"pagefrom"
		]),
		// 是否展示教育经历
		needEducation() {
			// 大专及以上 + 校招 + 应届生必填
			return (
				this.education > 3 &&
				(this.pagefrom === "fromXZ" || this.pagefrom === "fromCQXZ") &&
				this.workyears === 5
			);
		},
		// 最高学历
		getHighEdu() {
			const edus = [...this.educations];
			return edus.sort(
				(x, y) =>
					y.endDate.replace(/-/g, "") - x.endDate.replace(/-/g, "")
			)[0];
		}
	},
	created() {
		this.setPhotoUrl(this.pic);
		this.setSexClass(this.gender);
		this.setAge(this.birthday);
		this.setEducation(this.education);
		this.setWorkExperience(this.workyears);
	},
	watch: {
		pic(val) {
			this.setPhotoUrl(val);
		},
		gender(val) {
			this.setSexClass(val);
		},
		birthday(val) {
			this.setAge(val);
		},
		education(val) {
			this.setEducation(val);
		},
		workyears(val) {
			this.setWorkExperience(val);
		}
	},
	methods: {
		setPhotoUrl(val) {
			if (val) {
				this.photoUrl = val;
			} else {
				this.photoUrl =
					"//img.58cdn.com.cn/m58/app58/m_static/img/job/resume/newReleaseImg/user_default@2x.png";
			}
		},
		setSexClass(val) {
			if (val) {
				this.sexClass = "sex-female";
				this.sexBoxClass = "sex-female-box";
			} else {
				this.sexClass = "sex-male";
				this.sexBoxClass = "sex-male-box";
			}
		},
		setAge(val) {
			let date = new Date(),
				thisYear = date.getFullYear();
			this.age = thisYear - val;
		},
		setEducation(val) {
			// 教育经历从1开始
			this.educationText = config.educationList[val - 1];
		},
		setWorkExperience(val) {
			let index = config.experienceArray.indexOf(val); // 工作年限对应的index需要转一下
			this.workExperience = config.experienceList[index];
		},
		backBasic() {
			this.$router.go(-1);
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";
.basic-info-finish-box {
	background: #fff;
	margin-bottom: px2rem(20px);
}
.basic-user-info-finish-tit {
	font-size: px2rem(28px);
	color: #666;
	padding: px2rem(30px) px2rem(30px) px2rem(18px);
}
.modify {
	float: right;
	vertical-align: top;
}
.icon-modify {
	background: url(../../../assets/img/ic_edit.png) no-repeat;
	display: inline-block;
	width: px2rem(36px);
	height: px2rem(36px);
	background-size: contain;
	vertical-align: top;
}
.basic-info-finish {
	min-height: px2rem(212px);
	padding: px2rem(5px) 0 px2rem(30px) px2rem(38px);
}
.basic-info-finish-pic {
	width: px2rem(150px);
	height: px2rem(150px);
	border-radius: 50%;
	vertical-align: middle;
}
.basic-info-finish-detail {
	display: inline-block;
	width: px2rem(520px);
	overflow: hidden;
	font-size: px2rem(30px);
	color: #666;
	margin-left: px2rem(25px);
	vertical-align: middle;
}
.basic-info-finish-name {
	font-size: px2rem(38px);
	line-height: px2rem(38px);
	color: #000;
	margin: px2rem(12px) 0 px2rem(20px);
	div {
		display: inline-block;
	}
	.personal-info {
		width: px2rem(66px);
		height: px2rem(30px);
		display: inline-block;
		border-radius: px2rem(4px);
		font-size: px2rem(24px);
		color: #fff;
		text-align: center;
		margin: px2rem(-6px) 0 0 px2rem(5px);
		line-height: px2rem(28px);
		vertical-align: middle;
	}
	.sex-female-box {
		background: #ff9db4;
	}
	.sex-male-box {
		background: #96b5ef;
	}
	.sex {
		display: inline-block;
		width: px2rem(28px);
		height: px2rem(28px);
		vertical-align: middle;
		float: left;
	}
	.sex-female {
		background: url(../../../assets/img/ic_female_small.png) no-repeat;
		background-size: contain;
	}
	.sex-male {
		background: url(../../../assets/img/ic_male_small.png) no-repeat;
		background-size: contain;
	}
	.age {
		margin-left: px2rem(-4px);
		vertical-align: middle;
	}
}
.basic-outer {
	width: 100%;
	overflow: hidden;
}
.basic-info-finish-other {
	width: 100%;
	line-height: px2rem(32px);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	span {
		padding: 0 px2rem(16px);
		border-left: 1px solid #ccc;
	}
	.save-phone {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		padding-right: 0;
	}
	.save-edu {
		border: none;
		padding-left: 0;
	}
}
.basic-info-finish-edu {
	overflow: hidden;
	margin: px2rem(20px) 0 0;
	padding-right: px2rem(40px);
	white-space: nowrap;
	text-overflow: ellipsis;
	.edu-item {
		&:not(:last-child) {
			margin-right: px2rem(10px);
		}
	}
}
</style>



// WEBPACK FOOTER //
// index.vue?7876fcb9